import { render, staticRenderFns } from "./informationDialog.vue?vue&type=template&id=2605425e"
import script from "./informationDialog.vue?vue&type=script&lang=js"
export * from "./informationDialog.vue?vue&type=script&lang=js"
import style0 from "./informationDialog.vue?vue&type=style&index=0&id=2605425e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports